import { trackEventAndOmitTypeName } from './trackEventAndOmitTypeName';

export interface ImageEventData {
  schema: string;
  data: {
    event_name: string;
    property_id: string;
    user_action?: string;
    media: {
      url: string;
      index: number;
      type: string;
    };
  };
}

export const trackFullScreenCarouselView = (eventData: ImageEventData): void => {
  trackEventAndOmitTypeName(eventData);
};
